import React, { Component } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import Buttons from '../../Buttons';
// import Wrp from '../../../hoc/Wrp/Wrp';

class PopHoverlink extends Component {
  
    componentDidMount(){
      
    }
    render () {
      const {colData,id,header} = this.props;
      const eventsHandler = {
        onClick:() => (colData.clickHandler) ?
                colData.clickHandler(colData,colData.attributes):
                      'javascript(void)'
      }
      const access_mode = (colData.access_mode==undefined)? true:colData.access_mode;
      const show_user = (colData.show_user===undefined)? true:colData.access_mode;
      // console.log(this.props.value.access_mode);
      const href = (colData.href) ? colData.href:"#";
        return(
            <td key={"column"+this.props.id}>
              {(access_mode==true)? 
                <LinkContainer key={id} to={href} {...eventsHandler}>
                <a  id="popover-content" href="#" data-placement="left" data-toggle="popover" data-container="body" data-trigger="hover" data-html="true"  style="text-decoration: underline;"  {...header.attributes} {...colData.attributes}>
                        {colData.value}
                </a>
                </LinkContainer>
              :''}
              {colData.data?
                <div className="popover-content hide" >
                <p className="example example-1 mb-0">
                    {colData.data.map((value,valIndex)=>{
                        return( 
                            <span  key={valIndex} {...value.attributes}>{value.name}</span> 
                        )
                    })}
                 </p>
                </div>
              :''}
              {
                show_user===true?
                <span  className="pl-1" data-toggle="modal" data-target="#Lpermission" {...eventsHandler}> <i className="fas fa-user-edit fa-lg third_dark_color"></i> </span>
                :
                ''
              }              
            </td>
        );
    }
}

export default PopHoverlink;